import React from 'react'
export default function TermsAndCondition() {
  return (
    <div className="container">
      <div className="row terms_row">
        <div className="col-md-12">
          <h2 className="section-heading" style={{
            textTransform: "capitalize",
            textAlign: "center",
            marginBottom: "30px"
          }}> terms and conditions</h2>
       

          <>
           
            <style
              type="text/css"
              dangerouslySetInnerHTML={{
                __html:
                  "\n\t\t@page { size: 8.5in 11in; margin: 1in }\n\t\tp { line-height: 115%; text-align: left; orphans: 2; widows: 2; margin-bottom: 0.1in; direction: ltr; background: transparent }\n\t"
              }}
            />
           
            <p
              style={{
                lineHeight: "100%",
                textIndent: "0.5in",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <a name="_GoBack" />
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      <br />
                      Definitions:
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      1GM PAY INDIA DIGITAL MARKETING PRIVATE LIMITED Shop No-4,Nr
                      Dattaguru, Society, Sambhaji Chowk, Ulhasnagar-4, Kalyan, Thane-
                      421004, Maharashtra
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      2. “Card Member” or “Member” means a person holding a Valid Card and
                      making payment using a Valid Card;
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      3. “Card Organization” includes VISA, MasterCard, Rupay (GMpayCI)
                      and any other card organization as acceptable to GMpay presently or
                      in future, offering cred debit or any other card program to Issuers.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      4. “Cash @PoS”/ “Cash Withdrawal at PoS” is payment of cash by the
                      GMpay Retailer to the card member as per RBI guidelines circulated
                      from time to time
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      5. “Card” means a credit/debit card or a Prepaid wallet Bank under a
                      Card Program which will function as: a. an ATM card requiring a PIN
                      to validate Cardholder’s identity for access to ATMs, b. a
                      debit/prepaid card which may be used at merchant locations that are
                      equipped to accept PIN based cards, and c. as a debit/prepaid card
                      which will function on either the VISA or MasterCard or Rupay
                      payment networks. d. E Wallet/ M Wallet or such other prepaid
                      Payment Instrument covered under Reserve Bank of India (RBI)
                      guidelines
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      6. “Cardholders” will mean holders of valid Cards;
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      7. “Issuer” means any organization(s) issuing a Card, Wallet or any
                      kind of Prepaid Instrument
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      8. “POS” a device (including PSTN terminals, GPRS terminals and
                      MPOS) which accepts Card data for payments;
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      9. “Law” will include all applicable statutes, enactments, acts of
                      legislature, laws, ordinances, rules, bye-laws, regulations,
                      guidelines, directions, directive and orders of any government,
                      tribunal, board, court or recognized stock exchange and applicable
                      international treaties and regulations, in force at the relevant
                      time, and having the force of law;
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      10. “Licensed Rights” will mean the distinguishing characteristics
                      of the System include, without limitation, the names and marks
                      together with such othe trademarks, service marks, trade symbols,
                      emblems, designs, slogans, insignia and copyrights as GMpay has or
                      may hereafter acquire or develop and designate for use in connection
                      with the System.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      11. “GMpay Wallet” is a prepaid instrument issued by GMpay in
                      partnership with a Bank
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      12. “Wallet holders” will mean holders of GMpay/Third Party wallets
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      13. “GMpay” or “System” will mean the payment solution that provides
                      the Suite of Services (as defined below);
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      14. “GMpay Retailer” will mean the merchant, agent and/or Business
                      Correspondent who has licensed the use of the application and
                      pursuant to these terms and conditions provides GMpay Services at
                      his/her premises(GMpay Retailer Outlet);
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      15. “GMpay Services” will mean the set of services offered by the
                      GMpay System;
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      16. “Suite of Services” will mean the suite of services forming part
                      of the System. This suite of services may be updated from time to
                      time by GMpay with prom notification to the GMpay Retailer;
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      17. “GMpay Retailer Outlet” will mean the premises of operation of
                      the GMpay Retailer
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      18. “GMpay Retailer Guidelines” will mean the guidelines, terms of
                      use, manuals and or instructions furnished by GMpay and/or the
                      partners of GMpay from ti to time
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      19. “Partners” will mean the entities that GMpay partners with for
                      the provision of the GMpay Services
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      20. “Payment Instruments” will mean all types of modes of payment
                      such as GMpay Wallet, Credit Cards, Debit Cards, or any type of
                      Prepaid Instrument 21. “RBI” will mean the Reserve Bank of India as
                      established by the Reserve Bank of India Act,1934.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">SUITE OF SERVICES</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      1. The GMpay Services offered by the GMpay Retailer are as set out
                      in the document specific to each GMpay Retailer.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      2. The nature of services may be added/ modified based on market
                      needs.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">COMMISSION &amp; CHARGES</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      1. The details of the commission payable to the GMpay Retailer and
                      charges due for services will be provided through a separate letter.
                      Any change in th commission details will be communicated by way of
                      the System or a separate letter.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      2. Where commissions are due, GMpay will withhold applicable taxes
                      and pay the balance to the GMpay Retailer.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      LEGAL AND REGULATORY COMPLIANCE
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      1. GMpay grants to the GMpay Retailer a non-exclusive license to use
                      the GMpay System to operate and deliver the Suite of Services.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      2. The GMpay Retailer will operate the System and his operations as
                      a Business Correspondent in compliance with relevant Law, including
                      but not limit to the relevant rules and regulations as prescribed by
                      RBI (as amended from time to time).
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">COMPLIANCE OF TERMS OF USE</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      In addition to the obligations set out elsewhere in this Agreement,
                      the GMpay Retailer undertakes to operate the System and its
                      operations at the GMpay Retailer Outlet in accordance with the GMpay
                      Retailer Guidelines.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">STIPULATIONS OF USE</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">GMpay will PROVIDE:</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      1. Such assistance, training and services as GMpay, in its
                      discretion, determines what is required by the GMpay Retailer
                      including assistance by way of planning and implementation of market
                      development and promotional programs, in the manner it so chooses.
                      The GMpay Retailer understands that such training and services may
                      require payment of fees as may be separately communicated.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      2. Such other resources and assistance as may hereinafter be
                      developed and offered by GMpay to its other outlets/transaction
                      points, if any;
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">LICENSED RIGHTS</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      1. A sign board using the Licensed Rights for displaying outside the
                      shop in a prominent manner and a set of customer information display
                      material for display outside and inside the store;
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      2. The use of literature, brochures and basic technical data and
                      training aids as may be deemed fit and revised by GMpay from time to
                      time;
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">AUDIT AND INSPECTION</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      1. Both Parties recognize and acknowledge that the maintenance of
                      proper records of the transactions carried out by a GMpay Retailer
                      and onsite inspection of a GMpay Retailer’s premises and records are
                      prerequisites towards obtaining approval for appointment of GMpay
                      Retailers by GMpay Partners.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      2. GMpay, its Partners or any other person on behalf of GMpay may
                      conduct an on-site inspection of the GMpay Retailer Outlet, at any
                      time. The GMpay Retailer undertakes to maintain up to date, accurate
                      and true records and required registers in compliance with
                      applicable Law and GMpay Retailer Guideline
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      USAGE OF MOBILE NUMBER, COMMUNICATIONS RELATED TO USAGE &amp;
                      CONSENT
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      1. GMpay may send transaction information, transaction confirmation
                      information, Services related information, Company information or
                      promotional information or any such other information relevant for
                      the transaction via SMS, internet-based messaging applications like
                      WhatsApp, Voice call and email any other alternate communication
                      detail provided by the user.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      2. The user hereby unconditionally consents that such communications
                      via SMS, internet-based messaging applications like WhatsApp, voice
                      call, email any other mode by GMpay are: a. upon the request and
                      authorization of the user; b. 'transactional' and not an
                      'unsolicited commercial communication' as per the guidelines of
                      Telecom Regulation Authority of India (TRAI), and c. in compliance
                      with the relevant guidelines of TRAI or such other authority in
                      India and abroad.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      3. GMpay Retailers may upload information relating to transactions
                      with customers, including the sale of goods or services, costs,
                      amounts paid and payable, and details of goods and services, on the
                      GMpay Systems (such information is referred to as “Transaction
                      Information”). Transaction Information may be exchanged between
                      GMpay Retailer and customers through telephonic calls, text message,
                      WhatsApp, email, or other electronic mediums that would depend on
                      the contact details of GMpay Retailers and customers provided on
                      GMpay Systems.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">UNDERTAKINGS</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      GMpay as follows: 1. to operate the System and its operations at the
                      GMpay Retailer Outlet in accordance with applicable Law and the
                      GMpay Retailer Guidelines to the GMpay Retailer Outlet open and
                      operating for the time period as stipulated by the relevant laws.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      2. to observe such requirements with respect to use of GMpay and
                      GMpay’s Licensed Rights. The GMpay Retailer will always and
                      unequivocally mention a state that the GMpay Retailer is a retailer
                      of the System.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      3. to authorize GMpay to raise invoices on its behalf.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      4. to deduct the Merchant Discount Rates (as agreed with GMpay) when
                      making the final settlement to GMpay Retailer‘s wallet and or Bank
                      Account as communicated by the retailer
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      5. to ensure security of cash maintained at the GMpay Retailer
                      Outlet that will be used in the course of operations.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      6. to not deviate in any manner from the plans and specifications
                      stipulated by GMpay.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      7. to conduct all transactions in Indian Rupees unless otherwise
                      agreed.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">Card specific Undertakings</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      1. to honor and accept every valid Card when properly presented for
                      payment for a transaction. The GMpay Retailer will not engage in
                      acceptance or practices that discriminate against, or discourage the
                      use of any valid Card in favor of any other Card or any other
                      payment mode. The GMpay Retail will not, of his own accord, levy any
                      charges on the holder of any of the above mentioned payment
                      instruments for permitting the customer to use a valid payment
                      instrument. The GMpay Retailer will not place any minimum
                      transaction limit for using a valid Card unless specified by GMpay.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      2. To conduct the transaction such that after ensuring that the
                      instrument is a valid Card instrument , swipe the card on the PoS
                      terminal or enter the data of the prepaid instrument on the GMpay
                      app and enter the details of the transaction as displayed and ensure
                      that applicable Reserve Bank of India guidelines are followed. Where
                      relevant, the GMpay Retailer will ensure entering of PIN by the
                      payment instrument holder and to ensure that while entering of PIN
                      sufficient privacy is given to the payment instrument holder.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      3. To make best efforts to recover and retain any card a. in respect
                      of which a request has been made by a Card Organization to recover
                      the card; or b. which the GMpay Retailer has sufficient and
                      reasonable grounds to believe to be counterfeit, fraudulent or
                      stolen.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      4. to promptly notify GMpay of any such recovery and retention and
                      deliver the card so recovered to GMpay/ Card Organization within 24
                      (Twenty-Four) hours of such recovery and retention.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      5. to permit GMpay through its banking Partner for installation of
                      the PoS terminal/device at his premises and for de-installation of
                      the PoS terminal in case of de-boarding at the registered address
                      herewith. Prior to such installation, the details of the locations
                      will be provided by GMpay in writing to the relevant Partner.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      6. to under no circumstances, adopt unethical transaction practices
                      such as doing transactions with his own card, doing transactions
                      without a valid purchase etc.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      7. to under no circumstances, shift the equipment from its
                      designated location without prior consent of GMpay.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      8. To immediately notify GMpay about any changes in the contact
                      details like address, phone /mobile number, email id etc., for
                      updating in GMpay’s records. GMpay w ant be responsible for any loss
                      to the GMpay Retailer due to non-informing GMpay for any change in
                      communication details.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      9. To ensure that authorization in respect of charges will be
                      obtained by swiping/dipping the valid Card using the PoS terminal
                      (online authorization) provided /or by GMpay using the number of
                      prepaid instruments in case of GMpay Wallet as approved by GMpay. If
                      the GMpay Retailer accepts charges with authorization/printing of
                      chargte slip, neither GMpay nor the relevant Partner will be
                      responsible for such charges or any part thereof.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      10. To, under no circumstances, split the swipe/transaction amount
                      for a single purchase into 2(Two) or more transactions/charge slips.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      11. By presentation of the Charge Slip(s) (or its equivalent
                      electronic version), the GMpay Retailer represents and warrants
                      that: 1. No other Charge Slip has been or will be issued or
                      presented in respect of the same transaction. 2. The relevant Charge
                      Slip represents a genuine business Transaction undertaken by a Card
                      Member using a valid card.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      12. To ensure that in case of unsettled (open) transactions, GMpay
                      Retailer will settle the transactions at the end of the day+1. Non
                      settlement of transactions for more than 3 days from the date of
                      transaction attracts a penalty of 0.50% over and above the agreed
                      MDR payable in terms of VISA/MasterCard/Rupay guidelines or Rs.500/-
                      whichever is higher. It is also understood that such penalties may
                      be changed, with or without prior notice as per regulatory/Card
                      association guidelines from time to time.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      13. To settle the transaction in any case before 7 days failing
                      which GMpay Retailer loses the claim on the unsettled amount. In
                      case the GMpay Retailer unable to settle the transaction due to
                      software/ hardware issues, he needs to log a complaint with GMpay
                      within one hour of any such complaints.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      14. To understand the period of unsettled transactions and
                      interchange are subject to change as per Card
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      Organization/Bank/RBI/Rupay/GMpay merchant Services etc. and will be
                      notified to the GMpay Retailer from time to time.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">Licensed Rights</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      1. To not at any time or in any manner misuse or use the Licensed
                      Rights contrary to the specifications of use.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      2. To cooperate with GMpay in preventing infringement of the System
                      and the Licensed Rights including taking such action as may be
                      necessary in defense.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      3. To not have or acquire any right or interest of any kind in, or
                      in any part of, the Licensed Rights of Jaharvir Finvis Private
                      Limited or GMpay used or applied by the GMpay Retail under the
                      provisions of this Agreement.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      ACCEPTANCE OF CHARGES WITH RECOURSE-CHARGEBACKS
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      The GMpay Retailer agrees that any charges accepted by itself, which
                      proves to be uncollectible, and which were incurred in any of the
                      following circumstances will be the exclusive financial
                      responsibility of GMpay Retailer. The GMpay Retailer agrees to the
                      non-payment of such charges or the chargeback debit of such
                      uncollectable charges (as the case may be) by GMpay, without any
                      demur or protest:
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      1. Any charge which is not a valid charge and/or which is made by a
                      payment instrument, which is not a valid instrument at the time of
                      incurring of the charge by the holder.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      2. Any charge incurred outside the territory authorized for the use
                      of a valid Payment Instrument
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      3. Any charge incurred involving the forgery of the Card holder
                      signature/Wallet Holder PIN on the Charge Slip/GMpay Application
                      and/ or where GMpay or its Bank reasonably believes the transaction
                      to be irregular and/ or fraudulent.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      4. Any charges for merchandising or services in an amount in excess
                      of the advertised price.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      5. The Payment Instrument presented to the GMpay in respect of the
                      transaction was listed in a warning list or any other communication
                      or advice from time to time.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      6. Any charges with respect to which a Payment Instrument holder
                      refuses to pay because the merchandising or services purchased from
                      GMpay were n delivered or are not as promised or the merchandise was
                      defective or services deficient in any respect subject to
                      VISA/MasterCard/Rupay/GMpay Dispute Resolution Rules.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      7. Charges which the Card Organization/GMpay disputes or reports as
                      a retrieval request/fraud/chargeback.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      8. There is a violation of the terms and conditions in relation to a
                      transaction or any GMpay Retailer operating instructions/guidelines.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      9. Change of business activity/ business name/ business location
                      without informing GMpay
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">TERMINATION</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      1. If, at any time, GMpay determines that the GMpay Retailer has not
                      complied or conformed to the terms herein, GMpay will, upon giving
                      the GMpay Retailer fifteen (15) days’ prior written notice to remedy
                      / rectify the same, may direct the GMpay Retailer to suspend
                      operations and use of the System.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      2. In the event, the GMpay Retailer does not comply, GMpay will have
                      the right to obtain an injunction from a Court of competent
                      authority against such continuing non-compliance, non-conforming
                      with and/or operation of the GMpay Retailer Outlet and the GMpay
                      Retailer hereby consents, and will not object, to any such
                      injunction proceedings, if any, initiated by GMpay.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      3. Notwithstanding the grounds set out in clause IX above; the
                      occurrence of any of the following events will constitute a default
                      by the GMpay Retailer under this Agreement:
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      4. If the GMpay Retailer misuses/misrepresents the System or any of
                      the Licensed Rights of GMpay or otherwise impairs the goodwill
                      associated therewith or GMpay’s rights or interests therein.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      5. If the GMpay Retailer allows the operation of any other Business
                      Correspondent or any other competing business of GMpay in the same
                      outlet as committed for the GMpay Retailer
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      6. If the GMpay Retailer fails to remit any payment or part thereof
                      when due to GMpay.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      7. If the GMpay Retailer assigns or allows any unauthorized persons
                      to operate the System.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      8. If the GMpay Retailer will be in default under any lease or
                      sublease of the GMpay Retailer Outlets’ site / premises or loses the
                      right to possession thereof for any reason whatsoever.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      9. If the GMpay Retailer makes, or has made, any misrepresentation
                      to GMpay in connection with this Agreement or in conducting the
                      business licensed hereunder.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      10. If the GMpay Retailer defaults in performance of any other
                      obligation under this Agreement.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      11. If the GMpay Retailer Outlets ceases operations, without the
                      written consent of GMpay, for any reason for a period of more than
                      seven days except as a result of Act of God.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      12. If the GMpay Retailer, or any other person controlling,
                      controlled by, or under common control with the GMpay Retailer, will
                      be adjudged in solve or tried or convicted under any Law.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      13. Upon the occurrence of any the events set forth in Clause VI c.
                      above, GMpay may, without prejudice to any other rights or remedies
                      contained in this Agreement or provided by law or equity, terminate
                      this Agreement. Such termination will become effective after written
                      notice is given by GMpay to the GMpay Retailer.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      14. Notwithstanding anything contained in this Agreement, the GMpay
                      Retailer will be entitled to terminate this Agreement by giving to
                      GMpay not less than thirty (30) days’ prior notice in writing of its
                      intention to do so and the cause for which the termination is
                      occurring. At any time, GMpay reserves the right to waive such
                      notice period.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      15. Upon giving the notice of termination, as set out in Clauses VI
                      a. or c. above, or upon termination of this Agreement for any
                      reason, or upon expiration o the term hereof the GMpay Retailer
                      agrees as follows.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      16. To immediately cease to carry out all the GMpay business
                      platform transactions.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      17. To forthwith cease and desist from using the System and the
                      Licensed Rights or other rights &amp; procedures or methods of GMpay
                      or similar thereto,
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      18. To return all material in relation to the Licensed Rights, all
                      information including operational manuals, data, instructions,
                      literature, directions, and other manuals, plans and specifications,
                      designs, records, samples, models, programs, handbooks, or drawings
                      touching or concerning GMpay’s operations or business, without
                      retaining any copies by the GMpay Retailer;
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      19. To cease and forthwith desist from holding itself in any way as
                      a GMpay Retailer of GMpay or to show anything which would indicate
                      any relationship between it and GMpay.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      20. To permit GMpay’s representatives/agents/employees to enter the
                      GMpay Retailer’s premises and to remove or permanently cover all
                      signs or advertisements or effects identifiable in any way to
                      GMpay’s name or image.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">CONFIDENTIALITY</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      The GMpay Retailer acknowledges that during the pendency of this
                      Agreement, it will have access to proprietary information and trade
                      secrets and or information concerning the business or financial
                      affairs of GMpay and or of GMpay’s Partners (the “Confidential
                      Information”). The GMpay Retailer agrees a undertakes to treat the
                      Confidential Information as strictly secret and confidential and the
                      GMpay Retailer will, not without GMpay’s prior written consent
                      disclose or divulge the same or any part thereof to any person or
                      otherwise make any use of the same. This confidentiality covenant
                      will survive the termination of this Agreement without any limit in
                      point of time.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">ASSIGNMENT</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      1. The GMpay Retailer understands and agrees that GMpay retains the
                      right to transfer all assets, including the technology, in relation
                      to the System to any party it so deems fit (the “Transferee”) and
                      upon such transfer, the obligations, rights and duties owed by the
                      GMpay Retailer towards GMpay pursuant this Agreement will stand
                      transferred to the Transferee. For the avoidance of doubt, it is
                      clarified that upon such transfer being effective, the relationship
                      between the GMpay Retailer and GMpay will stand terminated.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      2. The GMpay Retailer understands and agrees that the
                      responsibilities, rights, obligations and interests accruing to him
                      pursuant to this Agreement are not transferable.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">INDEMNITY</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      The GMpay Retailer hereby agrees to indemnify GMpay, and keep GMpay
                      indemnified and hold GMpay harmless against all damages: actions,
                      proceedings, costs and expenses incurred by GMpay as a result of, or
                      in consequence of, arising from, or otherwise connected with any
                      default, failure or non-compliance or contravention by the GMpay
                      Retailer, in relation to the System (including maintenance and
                      operation of the GMpay Retailer Outlets by the GMpay Retailer) and
                      or the Licensed Rights. In addition, the GMpay Retailer will
                      indemnify (and not hold GMpay or its Bank responsible), and hereby
                      keeps GMpay and the Bank indemnified and harmless from and against
                      any claims, Chargebacks, demand, action, suits or proceeding,
                      liabilities, losses, costs, expenses, taxes, legal fees, fines,
                      penalties or damages asserted against or incurred or suffered by
                      GMpay or his Bank on account of acts or omissions of GMpay Retailer
                      in connection with the sale of goods and/or services (by GMpay
                      Retailer), the performance of this Agreement, breach of a contract
                      or duty by GMpay Retailer , mis of the PoS terminal/GMpay
                      Application or any other device provided/approved by GMpay, GMpay
                      Retailer’s failure to observe any of the procedures, requirements or
                      obligations to be complied with in accordance with the Rules/
                      by-laws or regulations of any Card Schemes/RBI, negligence or fraud
                      of any employee/servant/contractor etc. of GMpay Retailer, any of
                      the representations or warranties of GMpay Retailer becoming false
                      or untrue or on account of any dispute of GMpay Retailer with any
                      customer or other third party. GMpay Retailer and not GMpay or its
                      Bank will be responsible for the payment of any non-compliance fines
                      or other penalties resulting from non- completion or non-compliance
                      of the PCIDSS validation program or any other security standards as
                      laid
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      CHEQUE CASHING, CASH ADVANCES AND/OR CASH REFUNDS
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      1. GMpay Retailer will not allow or make any cash advances and/or
                      cash refunds directly to the Card Members/Wallet Holders and further
                      that GMpay its Bank will not be responsible or held liable for such
                      actions except for making transactions under Cash at PoS
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      2. Cash @ PoS: Disbursement of cash to the maximum limit prescribed
                      by RBI under the Cash @ PoS scheme at identified GMpay Retailer
                      Outlets. GMpay Retailer needs to accept the terms and conditions
                      under for doing the same.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">TENOR</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      This Agreement will come into force from the date of this Agreement
                      and remain in force for a period of 1 (One) year. GMpay may, however
                      reappoint or ren based on business performance, by issuing a renewal
                      letter signed by an authorized representative of GMpay, before
                      expiry of the agreement. If the GMpay Retailer wishes to renew his,
                      you will be required to comply with the terms and conditions as will
                      be made available on the renewal application
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">NOTICE</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      All notices required to be provided for by or under this Agreement
                      will be given in writing by prepaid registered post, or by hand or
                      courier or by register mail and will be forwarded to GMpay or the
                      GMpay Retailer at the addresses set out below unless other address
                      has been specified by a party hereto by written notice thereof to
                      the other party. To Jaharvir Finvis Private Limited Tower-B,
                      Floor-6th, Office No-615 &amp; 616, KLJ Noida One B 8, Block B,
                      Industrial Area, Sector 62, Noida, Uttar Pradesh 201301 To GMpay
                      Retailer To the Address as available on the records of GMpay
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">LIABILITY</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      GMpay will not be liable for any errors, misrepresentations or false
                      entries by the GMpay Retailer with respect to the System. GMpay is
                      not liable in case of loss of cash from the GMpay Retailer Outlet.
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">LIMITATION OF LIABILITY</font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      Under no circumstances will GMpay, its officers or directors be
                      liable to the GMpay Retailer or anyone else for any loss or injury
                      or any direct, indirect, or other consequential damages arising out
                      of or in connection with the use of the System, and the operations
                      as a GMpay Retailer. Without limiting the generality of the
                      foregoing, GMpay’s total aggregate liability arising from or related
                      to your operations as a GMpay Retailer whether in contract or tort
                      will not exceed Rs.1000/- (Rupees One Thousand only).
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      GOVERNING LAW AND JURISDICTION
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              style={{
                lineHeight: "100%",
                marginTop: "0.19in",
                marginBottom: "0.19in",
                background: "#ffffff"
              }}
            >
              <font face="Times New Roman, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font color="#212529">
                    <font face="Segoe UI, sans-serif">
                      This Agreement is governed by and will be construed in accordance
                      with the laws in force in India and the Courts at Noida Uttar
                      Pradesh, India will have exclusive jurisdiction to try disputes
                      arising under this Agreement. Each Party waives any right it has to
                      object to an action being brought in those courts including by
                      claiming that the action has been brought in an inconvenient forum,
                      or that those courts do not have jurisdiction
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p style={{ lineHeight: "108%", marginBottom: "0.11in" }}>
              <br />
              <br />
            </p>
          </>






        </div>
      </div>
    </div>
  );
}
